import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
//images
import komImg1 from '../../assets/img/route-104-kom-img1.png';
import komImg2 from '../../assets/img/route-104-kom-img2.png';

const KOM = ({language}) => {
    return (
        <section className="KOM">
            <Container>
                <Row>
                    <Col md={6} className='order-lg-2'>
                        <img className='kom-img1' src={komImg1} alt="" />
                        <img className='kom-img2' src={komImg2} alt="" />
                    </Col>
                    <Col md={6} className='order-lg-1'>
                        <h2>{language === "Chinese"? "103K挑戰組－KOM登山王／后" : "103K The Race – King of the Mountains"}<span><em>KOM</em></span></h2>
                        <div className="kom-bx">
                            {language === "Chinese" ? <p>❶ 賽程中設置兩段登山王爬坡區段，第一段為<span className='theme-color'>44K至51K</span>（147縣道3K南港二號橋至147縣道10K涼亭後），第二段為<span className='theme-color'>70K至75.5K</span>（台21線76K至70.5K），兩路段分別以晶片計時，以兩段加總時間作為排名依據。</p>
                                : <p>❶ The race features two King of the Mountains (KOM) climbs: the first from <span className='theme-color'>44K to 51K</span> (County Route 147 3K at Nangang No. 2 Bridge to just past the pavilion at County Route 147 10K) and the second from <span className='theme-color'>70K to 75.5K</span> (Route 21 76K to 70.5K). Each climb is chip-timed separately, and rankings are based on the combined time of both climbs.</p>}
                            <p>{language === "Chinese"? "❷ 登山王競賽依性別分組，取男女共二位總冠軍；須於10:50前抵達終點，方具登山王排名資格。" : "❷ The KOM competition is divided by gender, with one overall champion each for men and women. Riders must reach the finish before 10:50 to be eligible for the KOM ranking."}</p>
                            <p>{language === "Chinese"? "❸ 登山王冠軍可榮獲以下獎品與資格：" : "❸ The KOM champions will receive the following prizes and qualification:"}</p>
                            <ul>
                                <li>{language === "Chinese"? "環法榮譽登山王紅點衫車衣" : "Tour de France King of the Mountains Polka Dot Jersey"}</li>
                                <li>{language === "Chinese"? "舞台授獎儀式" : "On-stage award ceremony"}</li>
                                <li>{language === "Chinese"? "前往法國參加2027 L'Étape France 錦標賽資格" : "A qualifying spot for the 2027 L'Étape France Championship in France"}</li>
                                <li>{language === "Chinese"? "獎座" : "Trophy"}</li>
                            </ul>
                            <p className='small-text'>{language === "Chinese"? "※主辦單位保有賽事規則最終解釋權，並保有更動活動內容之權利，若有任何關於活動的最新消息，將於活動官網更新，以上活動事項如有未盡事宜，主辦單位得隨時修訂之，恕不另行通知。" : "*The organizers reserve the right of final interpretation of the race rules and the right to change the event program. Any updates will be posted on the official event website. The organizers may amend the above details at any time without prior notice."}</p>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default KOM
